import React from 'react'
import moment from 'moment'
import { connect } from 'react-redux'
import { Redirect } from 'react-router-dom'
import { Form, Grid, Header, Button, Icon } from 'semantic-ui-react'
import { FormValidation, Field } from '../components'
import { fields } from '../../common/lib/redux-fields'
import { createLocation, updateLocation } from '../../common/locations/actions'
import {
  validateCreate,
  validateUpdate,
} from '../../common/locations/validations'

const { Row, Column } = Grid

class LocationForm extends React.Component {
  async submit(e) {
    e.preventDefault()
    const { fields, submit, location, createLocation, updateLocation } = this.props
    const isUpdate = location && !!location._id
    const values = fields.$values()
    let submissionFunction = createLocation

    if (isUpdate) {
      values._id = location._id
      submissionFunction = updateLocation
    }

    if (await submit(values, submissionFunction) !== false) {
      fields.$reset()
    }
  }

  componentWillUnmount() {
    this.props.fields.$reset()
  }

  render() {
    const { fields, errors, submitting, submitSuccessfull } = this.props
    if (submitSuccessfull) return <Redirect to="/locations" />

    const fieldErrors = {}
    errors.forEach(error => {
      if (error.detail && error.detail.field) fieldErrors[error.detail.field] = error.message
    })

    return (
      <Form loading={submitting} size="big">
        <Grid>
          <Row>
            <Column>
              <Header as="h2">Základní údaje</Header>
            </Column>
          </Row>
          <Field label="Název lokace" {...fields.name} required error={fieldErrors.name} />
          <Field type="checkbox" label="Vyřazená lokace" {...fields.archived} />
          {fields.archivedAt.value &&
          <Row columns={2}>
            <Column><Icon color="red" name="remove" /> Vyřazeno dne:</Column>
            <Column>{moment(fields.archivedAt.value).format('D.M.YYYY HH:mm')}</Column>
          </Row>
          }
        </Grid>

        <Grid>
          <Row>
            <Column>
              <Button type="submit" onClick={(e) => this.submit(e)}>Uložit</Button>
            </Column>
          </Row>
        </Grid>
      </Form>
    )
  }
}

LocationForm.defaultProps = {
  location: null,
  errors: [],
  submitting: false,
  submitSuccessfull: false,
}

LocationForm.propTypes = {
  fields: React.PropTypes.object.isRequired,
  location: React.PropTypes.object,
  errors: React.PropTypes.array,
  submitting: React.PropTypes.bool,
  submitSuccessfull: React.PropTypes.bool,
}

LocationForm = fields(LocationForm, {
  path: 'LocationForm',
  fields: ['name','archived','archivedAt'],
  getInitialState: (props) => {
    const { location } = props
    if (location && location._id) return location.toJS()
    return {}
  },
})

LocationForm = FormValidation(LocationForm, (props) => {
  const { location } = props
  let submissionValidation
  if (location && location._id) submissionValidation = validateUpdate
  else submissionValidation = validateCreate
  return { submissionValidation }
})

export default connect(() => ({}), { createLocation, updateLocation })(LocationForm)



// WEBPACK FOOTER //
// ./src/browser/forms/Location.js